import { useLayoutEffect, useRef, useState } from 'react';
import { FAQS } from '../campaign';
import { FaqIcon, PlusIcon, TncIcon, ArrowIcon } from './Icons';

/* FAQs row (expands into the question list) and the Terms & Conditions row. */
export default function LinksSection({ faqs = FAQS, onTerms }) {
  const [open, setOpen] = useState(false);
  /* the list slides open by animating max-height; its target is the list's
     own content height, so any number of questions fits without a hard cap */
  const listRef = useRef(null);
  const [maxHeight, setMaxHeight] = useState(0);
  useLayoutEffect(() => {
    setMaxHeight(open && listRef.current ? listRef.current.scrollHeight : 0);
  }, [open, faqs]);

  return (
    <>
      <div className={`gq-row gq-faq${open ? ' gq-open' : ''}`}>
        <div className="gq-lead"><FaqIcon /></div>
        <div className="gq-t gq-lbl">FAQs</div>
        <div className="gq-trail"><PlusIcon /></div>
        <button
          type="button"
          className="gq-hit"
          aria-label="Toggle FAQs"
          aria-expanded={open}
          onClick={() => setOpen((v) => !v)}
        />
      </div>
      <div ref={listRef} className={`gq-faqlist${open ? ' gq-open' : ''}`} style={{ maxHeight }}>
        {faqs.map((f) => (
          <div key={f.q} className="gq-q">
            <div className="gq-qt">{f.q}</div>
            <div className="gq-qa">{f.a}</div>
          </div>
        ))}
      </div>

      <div className="gq-sep" />

      <div className="gq-row gq-tnc">
        <div className="gq-lead"><TncIcon /></div>
        <div className="gq-t gq-lbl">Terms &amp; Conditions</div>
        <div className="gq-trail gq-arr"><ArrowIcon /></div>
        <button type="button" className="gq-hit" aria-label="Open terms" onClick={onTerms} />
      </div>
    </>
  );
}
